import { jsx as o, jsxs as d } from "@emotion/react/jsx-runtime";
import { T as c } from "../Typography/Typography.js";
import { ErrorOutlineOutlined as y, ReportProblemOutlined as m, CheckCircleOutlineOutlined as p, InfoOutlined as v } from "@mui/icons-material";
import { CircularProgress as T } from "@mui/material";
import l from "@mui/material/Box";
import { styled as w } from "@mui/material/styles";
import { isValidElement as C } from "react";
import { toast as n, ToastContainer as O } from "react-toastify";
const x = w(l)(({ theme: r }) => ({
  "--toastify-color-info": (r.vars || r).palette.info.main,
  "--toastify-color-success": (r.vars || r).palette.success.main,
  "--toastify-color-warning": (r.vars || r).palette.warning.main,
  "--toastify-color-error": (r.vars || r).palette.error.main,
  "--toastify-color-progress-info": (r.vars || r).palette.info.main,
  "--toastify-color-progress-success": (r.vars || r).palette.success.main,
  "--toastify-color-progress-warning": (r.vars || r).palette.warning.main,
  "--toastify-color-progress-error": (r.vars || r).palette.error.main,
  "--toastify-spinner-color": (r.vars || r).palette.info.main
})), f = ({ title: r, message: t }) => /* @__PURE__ */ d(l, { children: [
  r && /* @__PURE__ */ o(c, { component: "h2", variant: "body1", children: r }),
  /* @__PURE__ */ o(c, { variant: "body2", children: t })
] }), g = {
  info: /* @__PURE__ */ o(v, { color: "info" }),
  success: /* @__PURE__ */ o(p, { color: "success" }),
  warning: /* @__PURE__ */ o(m, { color: "warning" }),
  error: /* @__PURE__ */ o(y, { color: "error" }),
  pending: /* @__PURE__ */ o(T, { size: 20 }),
  default: null
}, s = (r, t) => (a, i) => {
  const e = t ? { ...t, ...i } : i;
  return r(
    C(a) ? a : /* @__PURE__ */ o(f, { ...typeof a == "string" ? { message: a } : a }),
    {
      // apply the mui icons instead of the defaults
      icon: ({ type: u }) => g[e != null && e.isLoading ? "pending" : u] || null,
      ...e
    }
  );
}, b = (r) => (t, a) => {
  r(t, {
    // apply the mui icons instead of the defaults
    icon: ({ type: i }) => g[a != null && a.isLoading ? "pending" : i] || null,
    ...(a == null ? void 0 : a.message) && {
      render: () => /* @__PURE__ */ o(f, { message: a.message, title: a.title })
    },
    ...a
  });
}, k = (r) => /* @__PURE__ */ o(x, { children: /* @__PURE__ */ o(O, { ...r }) }), z = Object.assign((r) => s(n)(r), n, {
  info: s(n.info),
  success: s(n.success),
  error: s(n.error),
  warning: s(n.warning),
  warn: s(n.warn),
  loading: s(n.loading, { isLoading: !0 }),
  update: b(n.update)
});
export {
  k as T,
  z as t
};
